<template>
  <div class="container pano">
    <div class="pano__main">
      <div class="pano__canvas" @mousedown="mouseDown" @mouseup="mouseUp">
        <a-scene
          embedded
          vr-mode-ui="enabled: false"
          device-orientation-permission-ui="enabled: false"
        >
          <a-entity camera look-controls="reverseMouseDrag: true"></a-entity>
          <a-assets timeout="2000">
            <template v-for="value in source">
              <img :id="`pano-${value.id}`" :key="value.id" :src="value.src" />
            </template>
          </a-assets>
          <a-sky
            ref="pano"
            :src="`#pano-${count}`"
            animation="property: rotation; from: 0 0 0; to: 0 360 0; dur: 90000; easing: linear; loop: true;"
          ></a-sky>
        </a-scene>
      </div>
      <div class="pano__nav">
        <div class="pano__prev" @click="dec">PREV</div>
        <div class="pano__pagination">{{ this.count + " / " + this.source.length }}</div>
        <div class="pano__next" @click="inc">NEXT</div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.pano__main {
  position: relative;
  width: 100%;
  height: 100%;
}

.pano__canvas {
  width: 100%;
  height: 75vh;
}

.pano__nav {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #000000;
  padding: 20px;
  width: 100%;
  background: #ffffff;
}

.pano__nav > div {
  font-size: 12px;
  user-select: none;
}

.pano__pagination {
  text-align: center;
}

.pano__pagination {
  text-align: center;
}

.pano__prev,
.pano__next {
  cursor: pointer;
}
</style>

<script>
export default {
  title: "Panorama",
  props: {
    source: Array
  },
  data() {
    return {
      count: 1
    };
  },
  methods: {
    inc() {
      this.count < this.source.length
        ? this.count++
        : (this.count = this.source.length);
    },
    dec() {
      this.count === 1 ? (this.count = 1) : this.count--;
    },
    mouseDown(e) {
      if (e.type === "mousedown" || e.type === "touchstart") {
        this.$refs.pano.pause();
      }
    },
    mouseUp(e) {
      if (e.type === "mouseup" || e.type === "touchend") {
        this.$refs.pano.play();
      }
    }
  }
};
</script>
